import Vue from 'vue';
import Vuex from 'vuex';
import myList from './modules/myList'
import operaMyList from './modules/operaMyList'
import user from './modules/user'
import food from "./modules/food";
import mobileOrdering from "./modules/mobileOrdering";
import multipleBook from "./modules/multipleBook";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 1,
    pageDirection: 'fade',
    routeChain: []
  },
  mutations: {
    addRouteChain(state, route) {
      state.routeChain.push(route);
    },
    popRouteChain(state) {
      state.routeChain.pop();
    },
    setPageDirection(state, dir) {
      state.pageDirection = dir;
    }
  },
  modules: {
    myList,
    operaMyList,
    user,
    food,
    mobileOrdering,
    multipleBook
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js